import { Pipe, PipeTransform } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';


/**
 * Receives a value and returns it wrapped in an span element with the respected class
 * to assign a color based on if it's positive, negative or zero
 * If the percent signs is passed as argument, the symbols is returned at the of the transformed value
 * Floor: Applies the red and green color above and below the value passed by. Only works when colored.
 */
@Pipe({
    name: 'rmsNumberTransform',
    standalone: false
})
export class RmsNumberTransformPipe implements PipeTransform {
  transform(value: any, colored = true, decimals = 2, postFix = '%', currency?: string, floor = 0 ): string {
    if (value === null || value === undefined) {
      return value;
    }
    const curr = currency ? getCurrencySymbol(currency, 'wide') : '';
    if (colored) {
      const floatValue = parseFloat(parseFloat(value).toFixed(decimals));
      const colorClass = floatValue > floor ? 'text-success' : floatValue < (-1 * floor) ? 'text-danger' : '';
      return `<span class="${colorClass}">${curr}${parseFloat(value).toFixed(decimals)}${postFix ? postFix : ''}</span>`;
    } else {
      return `${curr}${parseFloat(value).toFixed(decimals)}${postFix ? postFix : ''}`;
    }

    /*
    //18 march, returns zero without decimals
    if (colored) {
      const parsedValue = Number(parseFloat(value).toFixed(decimals)) === 0 ? 0 : Number(parseFloat(value).toFixed(decimals));
      const colorClass = parsedValue > floor ? 'text-success' : parsedValue < (-1 * floor) ? 'text-danger' : '';
      return `<span class="${colorClass}">${curr}${parsedValue}${postFix ? postFix : ''}</span>`;
    }

    //Original
    const colorClass = value > floor ? 'text-success' : value < (-1 * floor) ? 'text-danger' : '';
    return `<span class="${colorClass}">${curr}${parseFloat(value).toFixed(decimals)}${postFix ? postFix : ''}</span>`;
    */
  }

}
